// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Actual,
} from './';

export default {
  path: 'actual',
  name: 'Actual',
  childRoutes: [
    { path: 'actual', name: 'Actual', component: Actual, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/actual/route.js